/**
 * Por qué ha salido este cliente en la búsqueda.
 *
 * Vive suelto y sin importar nada a propósito. Nació dentro del componente que
 * la usa, que importa `@/App` para el axios configurado, así que probar una
 * función de cinco líneas arrastraba la aplicación entera y el router. Una
 * función pura no debería estar detrás de un cliente HTTP.
 *
 * La usa `ClientSearchSelect`, que es el ÚNICO buscador de clientes del
 * proyecto. Hubo un segundo, `BuscadorClientes`, que hice sin darme cuenta de
 * que este ya existía; se retiró el 7-sep-2026.
 */

/** Los campos que el servidor busca pero la fila NO enseña. */
const CAMPOS_OCULTOS = [
  ['NIF', 'tax_id'],
  ['Teléfono', 'phone'],
  ['Nombre fiscal', 'fiscal_name'],
  ['Empresa', 'company'],
  ['Email plataforma', 'platform_email'],
];

/**
 * Devuelve "NIF: B12345678" cuando la coincidencia está en un campo que no se
 * ve, y null cuando está en el nombre o el email, que ya salen en la fila.
 *
 * El endpoint busca por siete campos y tres no viajan a la vista. Sin esto,
 * buscar un NIF devuelve "Bar Pepe - bar@pepe.es" y parece que el buscador ha
 * hecho algo raro.
 */
export function motivoDeCoincidencia(cliente, texto) {
  const t = (texto || '').trim().toLowerCase();
  if (!t || !cliente) return null;

  const contiene = (v) => Boolean(v) && String(v).toLowerCase().includes(t);

  // El nombre y el email ya se ven: repetirlos sería ruido.
  if (contiene(cliente.name) || contiene(cliente.email)) return null;

  const hit = CAMPOS_OCULTOS.find(([, clave]) => contiene(cliente[clave]));
  return hit ? `${hit[0]}: ${cliente[hit[1]]}` : null;
}

export default motivoDeCoincidencia;
